import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import ContentStackFeature from "./ContentStackFeature";
import ContentStackBenefits from "./ContentStackBenefits";
// Main component for Content Stack
export default function ContentStack() {
  
  // Data for the first section (features related to the Content Stack)
  const data1 = [
    "Data Hub Gateway API: The Data Hub Gateway API validates tokens and forwards requests to the appropriate services, ensuring secure and efficient communication within the Data Hub ecosystem.",
    "Core Device Hub: The Core Device Hub facilitates data transfer between devices and services based on specified topics, serving as a central component for seamless communication and coordination within the system.",
    "IoT Data Pipeline: The IoT Data Pipeline stores real-time IoT device data in a database and publishes this data to a Socket.IO server, facilitating efficient data storage and distribution for further processing and analysis.",
    "IoB Data Pipeline: The IoB Data Pipeline stores live IoB assets and site data in a database, then broadcasts it to a Socket.IO server for real-time access and analysis.",
  ];

  // Data for the second section (supporting data sources and insights)
  const data2 = [
    "Weather: The weather module retrieves weather information by querying an external weather API based on specified location parameters.",
    "Data Lake: The Data Lake serves as a repository for storing data related to devices, sites, assets, and historical records, consolidating diverse datasets for comprehensive analysis and insights.",
    "Environmental Data: Environmental Data refers to data collected from devices providing insights into the surrounding conditions.",
    "Operational Data: Operational Data includes data specific to GBR sites and assets, providing information crucial for operational management and decision-making.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["Content Stack Experience"]}
        bannerbodycopy="Integrate | Connect | Manage | Operate"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="ContentStack" />

      {/* Features Section */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Content Stack Features Section */}
      <ContentStackFeature />

      {/* Content Stack Benefits Section */}
      <ContentStackBenefits />

      {/* Call-to-Action Section */}
      <Container className="subSectionWrapper">
        <CTA
          href4="http://54.185.221.117:8901/v2/api-docs/"
          heading="Do you want to develop applications or integrate your legacy hardware and software..."
        />
      </Container>
    </>
  );
}

